export enum Members {
  COACH = 'coach',
  PLAYER = 'player'
}

export const MembersFunctionTranslation = {
  [Members.COACH]: 'coachInvite',
  [Members.PLAYER]: 'playerInvite'
};
